<div class="entity-config-page container-fluid">
  <div class="entity-config-shell d-flex flex-column gap-0 mx-auto px-2 position-relative">
    <blocking-loader-overlay
      :show="loading_sheets"
      :message="page_loading_message"
      :detail="page_loading_detail"
    />
    <section class="mb-4 pt-2">
      <div class="text-uppercase text-xxs secondary-color d-flex align-items-center gap-2 mb-2">
        <span>Home</span>
        <span>/</span>
        <span>Timesheets &amp; Billing</span>
      </div>
      <div class="d-flex flex-column flex-md-row align-items-md-start justify-content-between gap-3 mb-3">
        <h1 class="entity-page-title secondary-color lh-sm mb-0">Timesheets &amp; billing</h1>
        <div class="d-flex align-items-center gap-2 flex-wrap justify-content-md-end">
          <label for="timesheet-month-filter" class="small fw-semibold secondary-color mb-0">Month</label>
          <select
            id="timesheet-month-filter"
            v-model="selected_month"
            class="form-select form-select-sm entity-binding-control rounded-pill px-4 w-auto"
          >
            <option v-for="month in months" :key="month.value" :value="month.value">{{ month.label }}</option>
          </select>
        </div>
      </div>

      <section class="row g-3">
        <div v-for="metric in metrics" :key="metric.label" class="col-12 col-md-6 col-xl-3">
          <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-4 bg-white">
            <div class="d-flex flex-column justify-content-start">
              <span class="entity-metric-label secondary-color text-uppercase d-block mb-3">
                {{ metric.label }}
              </span>
              <div class="entity-metric-value secondary-color lh-1 mb-0">{{ metric.value }}</div>
              <div class="text-x mb-0 mt-3" :class="metric.change_class">{{ metric.change }}</div>
            </div>
          </article>
        </div>
      </section>
    </section>

    <section class="row g-0 mt-2">
      <div class="col-12 p-0 m-0">
        <div class="border-0 pt-2 pb-3 h-100 mt-0">
          <div class="d-flex flex-column flex-xl-row align-items-xl-center justify-content-between gap-3 mb-3">
            <div>
              <h1 class="entity-page-title secondary-color lh-sm mb-1">Submitted timesheets</h1>
              <div class="entity-panel-caption small text-dark">{{ selected_month_label || '-' }} &middot; {{ month_scoped_sheets.length }} handlers in scope</div>
            </div>

            <div class="d-flex align-items-center gap-2 flex-wrap justify-content-xl-end">
              <label for="timesheet-week-filter" class="small fw-semibold secondary-color mb-0">Week</label>
              <select
                id="timesheet-week-filter"
                v-model="selected_week"
                class="form-select form-select-sm entity-binding-control rounded-pill px-4 w-auto"
              >
                <option value="">All weeks</option>
                <option v-for="week in weeks" :key="week.value" :value="week.value">{{ week.label }}</option>
              </select>
              <button type="button" class="btn btn-light btn-sm rounded-small border entity-audit-btn px-3" @click.prevent="export_timesheets">Export</button>
            </div>
          </div>

          <div v-if="sheets_error" class="alert alert-warning py-2 px-3 small mb-3" role="alert">
            {{ sheets_error }}
          </div>

          <div class="d-flex flex-wrap gap-2 mb-3">
            <button
              v-for="filter in filters"
              :key="filter.key"
              type="button"
              class="btn btn-sm rounded-pill px-3"
              :class="active_filter === filter.key ? 'btn-primary-dark' : 'btn-light border secondary-color'"
              @click="set_filter(filter.key)"
            >
              {{ filter.label }} <span class="opacity-75">{{ filter.count }}</span>
            </button>
          </div>

          <div class="company-cases-table-wrap shadow">
            <div class="table-responsive">
              <table class="table company-cases-table align-middle mb-0">
                <thead>
                  <tr>
                    <th class="text-center">
                      <input class="form-check-input mt-0" type="checkbox">
                    </th>
                    <th>Handler</th>
                    <th>Week / Period</th>
                    <th>Cases</th>
                    <th>Billable</th>
                    <th>Non-Bill</th>
                    <th>Split</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th class="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(sheet, index) in filtered_sheets" :key="sheet.id">
                    <td class="px-3 py-3 text-center">
                      <input class="form-check-input mt-0" type="checkbox">
                    </td>
                    <td class="px-3 py-3">
                      <div class="d-flex align-items-center gap-3">
                        <span
                          class="avatar-circle text-white fw-bold flex-shrink-0"
                          :class="[
                            index % 5 === 0 ? 'bg-success' : '',
                            index % 5 === 1 ? 'bg-primary' : '',
                            index % 5 === 2 ? 'bg-warning text-dark' : '',
                            index % 5 === 3 ? 'bg-info text-dark' : '',
                            index % 5 === 4 ? 'bg-dark' : ''
                          ]"
                        >
                          {{ sheet.initials }}
                        </span>
                        <div>
                          <div class="company-case-title">{{ sheet.handler }}</div>
                          <div class="company-case-subtitle text-uppercase">{{ sheet.role }}</div>
                        </div>
                      </div>
                    </td>
                    <td class="px-3 py-3">
                      <div class="company-case-title">{{ sheet.week }}</div>
                      <div class="company-case-subtitle">{{ sheet.submitted_meta }}</div>
                    </td>
                    <td class="px-3 py-3">
                      <div class="company-case-owner">{{ sheet.cases }}</div>
                    </td>
                    <td class="px-3 py-3">
                      <div class="company-case-owner secondary-color">{{ sheet.billable }}</div>
                    </td>
                    <td class="px-3 py-3">
                      <div class="company-case-owner text-secondary">{{ sheet.non_bill }}</div>
                    </td>
                    <td class="px-3 py-3">
                      <div class="progress workflow-progress-thin rounded-pill mb-1 bg-body-secondary">
                        <div
                          class="progress-bar"
                          :class="sheet.split_label.includes('below') ? 'w-75 bg-warning' : 'w-100 bg-success'"
                          role="progressbar"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      <div class="company-case-subtitle" :class="sheet.split_text_class">{{ sheet.split_label }}</div>
                    </td>
                    <td class="px-3 py-3">
                      <div class="company-case-title">{{ sheet.amount }}</div>
                      <div class="company-case-subtitle">{{ sheet.rate }}</div>
                    </td>
                    <td class="px-3 py-3">
                      <span class="company-case-domain" :class="sheet.status_badge_class">
                        {{ sheet.status }}
                      </span>
                    </td>
                    <td class="px-3 py-3 text-end">
                      <div class="company-case-actions justify-content-end">
                        <button
                          type="button"
                          class="company-case-view-btn"
                          @click="open_review_modal(sheet)"
                        >
                          {{ sheet.action_label }}
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="!loading_sheets && !filtered_sheets.length">
                    <td colspan="10" class="px-4 py-4 text-center text-secondary small">No timesheets match this filter.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <div
    v-if="selected_review_sheet"
    class="timesheet-review-backdrop"
    @click.self="close_review_modal"
  >
    <section
      class="timesheet-review-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="timesheet-review-title"
    >
      <header class="timesheet-review-header">
        <div class="d-flex align-items-start gap-3 min-w-0">
          <span
            class="timesheet-review-avatar text-white fw-bold flex-shrink-0"
            :class="selected_review_sheet.status_key === 'approved' ? 'bg-success' : selected_review_sheet.status_key === 'disputed' ? 'bg-danger' : 'bg-dark'"
          >
            {{ selected_review_sheet.initials }}
          </span>
          <div class="min-w-0">
            <div class="d-flex align-items-baseline flex-wrap gap-2">
              <h2 id="timesheet-review-title" class="timesheet-review-title mb-0">
                {{ selected_review_sheet.handler }}
              </h2>
              <span class="timesheet-review-reference">{{ selected_review_sheet.reference }}</span>
            </div>
            <p class="timesheet-review-meta mb-0">
              {{ selected_review_sheet.role }} - {{ selected_review_sheet.week }} - {{ selected_review_sheet.submitted_meta }}
            </p>
          </div>
        </div>
        <button type="button" class="timesheet-review-close" aria-label="Close review" @click="close_review_modal">
          <i class="bi bi-x-lg"></i>
        </button>
      </header>

      <div class="timesheet-review-body">
        <div class="timesheet-review-alert">
          <strong>Awaiting your review.</strong>
          Approving will mark this week ready to invoice. Use Return below to query specific entries.
        </div>

        <div v-if="selected_review_sheet.review_comment" class="alert alert-light border py-2 px-3 small">
          <strong>Latest reviewer note:</strong> {{ selected_review_sheet.review_comment }}
        </div>

        <section class="timesheet-review-summary">
          <div>
            <span class="timesheet-review-kicker">Billable</span>
            <strong class="timesheet-review-summary-value">{{ selected_review_sheet.billable }}</strong>
            <span class="timesheet-review-summary-note">{{ selected_review_sheet.rate }} - {{ selected_review_sheet.amount }}</span>
          </div>
          <div>
            <span class="timesheet-review-kicker">Non-billable</span>
            <strong class="timesheet-review-summary-value is-muted">{{ selected_review_sheet.non_bill }}</strong>
            <span class="timesheet-review-summary-note">Capacity - no charge</span>
          </div>
          <div>
            <span class="timesheet-review-kicker">Total logged</span>
            <strong class="timesheet-review-summary-value">{{ selected_review_sheet.total_logged }}</strong>
            <span class="timesheet-review-summary-note">{{ selected_review_sheet.split_label }}</span>
          </div>
          <div class="timesheet-review-invoice">
            <span class="timesheet-review-summary-note">Invoice total</span>
            <strong>{{ selected_review_sheet.amount }}</strong>
          </div>
        </section>

        <div class="timesheet-review-section-label">
          Line items - {{ review_entries(selected_review_sheet).length }} entries
        </div>

        <div class="timesheet-review-lines">
          <div class="timesheet-review-line timesheet-review-line-head">
            <span>Activity</span>
            <span>Hours</span>
            <span>Billable?</span>
            <span>Amount</span>
          </div>
          <div
            v-for="(entry, index) in review_entries(selected_review_sheet)"
            :key="`${entry.code}-${index}`"
            class="timesheet-review-line"
          >
            <div class="timesheet-review-activity">
              <span>{{ entry.code }}</span>
              <strong>{{ entry.activity }}</strong>
            </div>
            <strong class="timesheet-review-hours">{{ entry.hours }}</strong>
            <div>
              <span class="timesheet-review-billable" :class="{ 'is-non-bill': !entry.billable }">
                <i class="bi bi-circle-fill"></i>
                {{ entry.billable ? 'Billable' : 'Non-bill' }}
                <i class="bi bi-lock-fill"></i>
              </span>
            </div>
            <span class="timesheet-review-amount">{{ entry.amount }}</span>
          </div>
          <div
            v-for="(entry, index) in review_entries(selected_review_sheet).filter((item) => item.evidence_files && item.evidence_files.length)"
            :key="`evidence-${entry.code}-${index}`"
            class="timesheet-review-report-entry"
          >
            <div>
              <span>Evidence for {{ entry.code }} &middot; {{ entry.activity }}</span>
              <strong>{{ entry.evidence_files.length }} file{{ entry.evidence_files.length === 1 ? '' : 's' }} submitted</strong>
            </div>
            <div class="timesheet-review-report-entry-meta flex-wrap">
              <a
                v-for="file in entry.evidence_files"
                :key="file.id || file.name"
                :href="file.url || '#'"
                class="btn btn-light border btn-sm"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ file.name || 'Open evidence' }}
              </a>
            </div>
          </div>
          <div class="timesheet-review-line timesheet-review-totals">
            <strong>Totals</strong>
            <strong>{{ selected_review_sheet.total_logged }}</strong>
            <strong>{{ selected_review_sheet.billable }} billable</strong>
            <strong>{{ selected_review_sheet.amount }}</strong>
          </div>
        </div>

        <div class="timesheet-review-lock-note">
          Approving locks this timesheet against further handler edits. The invoice will route to the tenant's billing party as configured in <em>Tenant - Billing setup.</em>
        </div>
        <div class="timesheet-review-section-label">
          Reviewer note
        </div>
        <textarea
          v-model="review_comment"
          class="form-control"
          rows="3"
          :placeholder="selected_review_sheet.status_key === 'approved' ? 'Optional approval note' : 'Explain what must be corrected before resubmission'"
          :disabled="saving_review_action"
        ></textarea>
        <div class="timesheet-review-section-label">
          Billable hours report data
        </div>

        <section
          v-for="section in review_billable_report_sections(selected_review_sheet)"
          :key="section.title"
          class="timesheet-review-report-section"
        >
          <h3 class="timesheet-review-report-title">{{ section.title }}</h3>

          <div v-if="section.type === 'metrics'" class="timesheet-review-report-metrics">
            <div
              v-for="row in section.rows"
              :key="row.metric"
              class="timesheet-review-report-metric"
            >
              <span>{{ row.metric }}</span>
              <strong>{{ row.value }}</strong>
            </div>
          </div>

          <div v-else-if="section.type === 'table'" class="timesheet-review-report-table-wrap">
            <table class="timesheet-review-report-table">
              <thead>
                <tr>
                  <th v-for="column in section.columns" :key="column.key">{{ column.label }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, row_index) in section.rows" :key="`${section.title}-${row_index}`">
                  <td v-for="column in section.columns" :key="column.key">
                    {{ row[column.key] }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else-if="section.type === 'grouped_entries'" class="timesheet-review-report-groups">
            <div
              v-for="group in section.groups"
              :key="group.title"
              class="timesheet-review-report-group"
            >
              <h4>{{ group.title }}</h4>
              <div
                v-for="(row, row_index) in group.rows"
                :key="`${group.title}-${row_index}`"
                class="timesheet-review-report-entry"
              >
                <div>
                  <span>{{ row.date || 'No date' }} &middot; {{ row.timekeeper }} &middot; {{ row.title }}</span>
                  <strong>{{ row.task }}</strong>
                </div>
                <div class="timesheet-review-report-entry-meta">
                  <span>{{ row.billable_hours }}h billable</span>
                  <span>{{ row.non_billable_hours }}h non-billable</span>
                  <strong>{{ row.total_value }}</strong>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <footer class="timesheet-review-footer">
        <button type="button" class="btn btn-light border rounded-small px-4" @click="close_review_modal" :disabled="saving_review_action">Close</button>
        <button type="button" class="btn btn-light border rounded-small px-4" @click="update_review_status('disputed')" :disabled="saving_review_action">
          {{ saving_review_action ? 'Saving...' : 'Return for revision' }}
        </button>
        <button type="button" class="btn btn-primary-dark rounded-small px-4" @click="update_review_status('approved')" :disabled="saving_review_action">
          {{ saving_review_action ? 'Saving...' : 'Approve - ready to invoice' }}
        </button>
      </footer>
    </section>
  </div>
</div>
